export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover o bloqueio <strong>' + this.currentEntity.name + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/index/resources/computed.js